import { format } from 'date-fns';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import Countdown from './components/Countdown/Countdown';
import StifledCountdown from './components/StifledCountdown/StifledCountdown';

export interface Props {
  completed?: boolean;
  running?: boolean;
  endTime: number;
  startTime: number;
  count: number;
  urgentCount?: boolean;
}

const TimedStatus: React.FC<Props> = ({
  completed = false,
  running = false,
  endTime,
  startTime,
  count,
  urgentCount
}) => {
  const stifleRequired = useSelector(select.casino.stifleUrgencyRequired);
  const doStifle = stifleRequired && urgentCount;
  const time = running ? endTime : startTime;

  if (completed) {
    return <span>{format(endTime, 'HH:mm')}</span>;
  }

  if (doStifle) {
    return <StifledCountdown time={time} count={count} />;
  }

  return <Countdown time={time} count={count} />;
};

export default TimedStatus;
